import { Box, Skeleton } from "@mui/material";

export const ChipSkeleton = () => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Skeleton sx={{ borderRadius: 2 }} variant="rounded" width="80px" height="32px" />
    </Box>
);
